/**
  * @function evalute - evaluate emcoCutPipeBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const contentPathOfPipe = await sourceEvaluator(source.contentPathOfPipe);
  const numberOfCuts = (await sourceEvaluator(source.numberOfCuts)) || 1;
  if (!contentPathOfPipe) {
    return undefined;
  }
  if (numberOfCuts <= 0) {
    return undefined;
  }
  const referencedPipeIdentifier = await sourceEvaluator({
    type: 'readReferencedContentBehavior',
    contentPath: "".concat(contentPathOfPipe, "/?/identifier")
  });
  const referencedPipeline = await sourceEvaluator({
    type: 'readReferencedContentBehavior',
    contentPath: "".concat(contentPathOfPipe, "/?/pipeline")
  });
  const referencedHeat = await sourceEvaluator({
    type: 'readReferencedContentBehavior',
    contentPath: "".concat(contentPathOfPipe, "/?/parts/wholePipe/heat")
  });
  const general = await sourceEvaluator({
    type: 'readReferencedContentBehavior',
    contentPath: "".concat(contentPathOfPipe, "/?/general")
  });
  const location = await sourceEvaluator({
    type: 'readReferencedContentBehavior',
    contentPath: "".concat(contentPathOfPipe, "/?/location")
  });
  const wallThickness = await sourceEvaluator({
    type: 'readReferencedContentBehavior',
    contentPath: "".concat(contentPathOfPipe, "/?/wallThickness")
  });
  const coatingType = await sourceEvaluator({
    type: 'readReferencedContentBehavior',
    contentPath: "".concat(contentPathOfPipe, "/?/coatingType")
  });
  const seam = await sourceEvaluator({
    type: 'readReferencedContentBehavior',
    contentPath: "".concat(contentPathOfPipe, "/?/seam")
  });
  const allExistingPipes = await sourceEvaluator({
    type: 'queryEntityBehavior',
    entityName: 'Form',
    properties: ['id', 'content'],
    equals: {
      'formType/identifier': 'pipe'
    },
    ifContent: {
      atPath: '/parentPipeIdentifier',
      equals: referencedPipeIdentifier
    }
  });
  const totalPipes = allExistingPipes.length;
  const pipeCollection = {};
  for (let i = 0; i < numberOfCuts + 1; i += 1) {
    const identifier = "".concat(referencedPipeIdentifier, " P").concat(totalPipes + (i + 1));
    const newPipeContent = {
      identifier,
      // P1, P2, P3... PX
      title: "Pipe: ".concat(identifier),
      parentPipeIdentifier: referencedPipeIdentifier,
      pipeline: referencedPipeline,
      general: {
        line: general.line,
        manufacturer: general.manufacturer,
        grade: general.grade,
        diameter: general.diameter
      },
      location,
      wallThickness,
      coatingType,
      seam,
      parts: {
        wholePipe: {
          heat: referencedHeat
        }
      }
    };
    // eslint-disable-next-line no-await-in-loop
    const pipeId = await sourceEvaluator({
      type: 'addFormBehavior',
      initialContent: newPipeContent,
      formTypeIdentifier: 'pipe'
    });
    pipeCollection["cutPipeCollectionItem".concat(i)] = {
      pipeReference: {
        [pipeId]: {
          _formRef: pipeId
        }
      }
    };
  }
  return pipeCollection;
};
module.exports = {
  evaluate
};